import { createContext } from 'react'

export type LoaderContextProps = {
  isLoading: boolean
  startLoading: () => void
  stopLoading: () => void
}

export const LoaderContext = createContext<LoaderContextProps>({} as LoaderContextProps)
